import { useCallback, useEffect, useSyncExternalStore } from "react";
import { useBindingCtx, useDomains, useEditorStore } from "../../../state/editor/useEditor";
import { basicEngineFor, type BasicEngine } from "./applyEngine";

/**
 * The shared Basic/AI engine, kept current with the binding ctx, re-rendering
 * the caller whenever the engine changes something or any slice a look field
 * reads from moves (so the meters follow Advanced edits too).
 */
export function useBasicEngine(): BasicEngine {
  const store = useEditorStore();
  const ctx = useBindingCtx();
  const engine = basicEngineFor(store);
  engine.setCtx(ctx);

  useDomains(["scene", "postFX", "groups", "selection", "material"]);
  useSyncExternalStore(
    useCallback((cb) => engine.subscribe(cb), [engine]),
    () => engine.getVersion(),
  );

  useEffect(() => {
    void engine.ensureMaterials();
    // The harnesses drive Basic mode through this, the way they read the
    // store through `__editorStore`. Dev builds only.
    if (import.meta.env.DEV) (window as unknown as { __basicApply: BasicEngine }).__basicApply = engine;
  }, [engine]);

  return engine;
}
